module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.required && !_vm.field.hide
      }),
      expression: "{required: required && !field.hide}"
    }],
    attrs: {
      "lang": "en",
      "format": _vm.userDateFormat,
      "value-type": _vm.backendDateFormat,
      "confirm": false,
      "value": _vm.value,
      "prefix-class": "xmx",
      "name": _vm.field.name,
      "data-vv-as": _vm.field.description,
      "placeholder": _vm.userDateFormat,
      "input-attr": {
        name: _vm.field.name,
        id: 'dp-' + _vm.field.name
      },
      "disabled": _vm.locked
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cd39a06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/DateRender.vue
// module id = 1657
// module chunks = 1